import { Visibility, VisibilityOff } from '@mui/icons-material';
import { IconButton, InputAdornment } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PasswordTextField } from './PasswordTextField';

interface PasswordTextInputProps {
  label: string;
  value: string;
  isRequired?: boolean;
  onChange: any;
  error?: boolean;
  match?: boolean;
  testId?: string;
}

export function LoginPasswordInput({
  label,
  value,
  isRequired = false,
  onChange,
  error,
  match,
  testId,
}: Readonly<PasswordTextInputProps>) {
  const [showPassword, setShowPassword] = useState(false);

  const { t } = useTranslation('authentication');

  const determineMatchText = (value: string, match: boolean | undefined) => {
    if (match !== undefined) {
      return match ? t('register.passwordMatch') : /* istanbul ignore next */ t('register.passwordDoesNotMatch');
    }
    return undefined;
  };

  return (
    <PasswordTextField
      label={label}
      value={value}
      onChange={onChange}
      type={showPassword ? /* istanbul ignore next */ 'text' : 'password'}
      required={isRequired}
      helperText={determineMatchText(value, match)}
      match={match}
      InputProps={{
        autoComplete: 'current-password',
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={/* istanbul ignore next */ () => setShowPassword(!showPassword)}
              aria-label="toggle password visibility"
              size="large"
            >
              {showPassword ? /* istanbul ignore next */ <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
      // eslint-disable-next-line react/jsx-no-duplicate-props
      inputProps={{
        'data-testid': testId,
      }}
      error={!!error}
    />
  );
}
